/**
 * Styles for ExportLimitErrorModal.
 * Design: Figma Export Error - https://www.figma.com/file/tOWB1KeKlPB63y5q0rV6XA (node 12667:8831)
 */
export default (theme) => ({
    errorIconCircle: {
        width: 52,
        height: 52,
        borderRadius: '50%',
        backgroundColor: 'var(--error-red-main, #e32d4e)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    errorIcon: {
        fontSize: 32,
    },
    contentBox: {
        paddingTop: 0,
        paddingBottom: theme.spacing(1),
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    title: {
        fontFamily: 'var(--font-body, "Inter", sans-serif)',
        fontWeight: 700,
        fontSize: 20,
        lineHeight: 1,
        color: 'var(--navy-main, #061e44)',
    },
    body: {
        fontFamily: 'var(--font-body, "Inter", sans-serif)',
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: '0.32px',
        color: 'var(--grey-110, #333)',
    },
});

/** Modal wrapper dimensions - passed to Modal styles.mainWrapperStyles */
export const mainWrapperStyles = {
    width: 420,
    maxWidth: '90vw',
};

/** Hide cancel button - passed to Modal cancelButtonProps */
export const cancelButtonProps = {
    sx: { display: 'none' },
};

/** Primary action button (Update Selection) - passed to Modal continueButtonProps */
export const continueButtonProps = {
    variant: 'outlined',
    sx: {
        borderColor: 'var(--navy-main, #061e44) !important',
        color: 'var(--navy-main, #061e44) !important',
        backgroundColor: 'white !important',
        '&:hover': {
            borderColor: 'var(--navy-main, #061e44) !important',
            backgroundColor: 'rgba(6, 30, 68, 0.04) !important',
        },
    },
};
